import React, { useState } from 'react';
import { Sprite, NineSlicePlane } from '@pixi/react';
import { gameStateManager } from '../../App';

const PixiScaledSprite = ( { x, y, imageSrc, stageRenderData, ...props } ) =>
{
  const [ hoverTint, setHoverTint ] = useState( null );

  const stageHeight = stageRenderData.height;
  const renderScale = stageRenderData.scale;
  const stageHeightRef = gameStateManager.canvasRefHeight;

  const setupProps =
  {
    x: x,
    y: ( y / stageHeightRef ) * stageHeight,
  }

  if( props.width )
  {
    setupProps.width = props.width * renderScale * ( props.scale ?? 1 );
  }

  if( props.height )
  {
    setupProps.height = props.height * renderScale * ( props.scale ?? 1 );
  }

  if( props.onHoverTint )
  {
    setupProps.pointerover = () => setHoverTint( props.onHoverTint );
    setupProps.pointerout = () => setHoverTint( null );
  }

  if( props.isNineSlice )
  {
    setupProps.leftWidth = ( props.cornerRadius ?? 10 );
    setupProps.topHeight = ( props.cornerRadius ?? 10 );
    setupProps.rightWidth = ( props.cornerRadius ?? 10 );
    setupProps.bottomHeight = ( props.cornerRadius ?? 10 );
    setupProps.pivot = {
      x: ( props.width * renderScale ) * ( props.anchor && props.anchor.x ? props.anchor.x : 0 ),
      y: ( props.height * renderScale ) * ( props.anchor && props.anchor.y ? props.anchor.y : 0 )
    };

    return (
      <NineSlicePlane
        image={ imageSrc }
        tint={ hoverTint != null ? hoverTint : ( props.tint ?? '0xffffff' ) }
        alpha={ props.alpha ? props.alpha : 1 }
        { ...setupProps }
        eventMode={ props.onClick ? 'static' : 'none' }
        pointerdown={ ( props.onClick ?? null ) }
        buttonMode={ props.buttonMode ?? false }

      />
    );
  }
  else
  {
    return (
      <Sprite
        image={ imageSrc }
        tint={ hoverTint != null ? hoverTint : ( props.tint ?? '0xffffff' ) }
        alpha={ props.alpha ? props.alpha : 1 }
        // scale={ ( props.scale ?? 1 ) * renderScale }
        { ...setupProps }
        anchor={ ( props.anchor ? props.anchor : 0 ) }
        eventMode={ props.onClick ? 'static' : 'none' }
        pointerdown={ ( props.onClick ?? null ) }
        buttonMode={ props.buttonMode ?? false }
      />
    );
  }
}

export default PixiScaledSprite;
